import React from "react"
import { toast } from "react-toastify"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { v4 as uuidv4 } from "uuid"

import {
  addOrderItem,
  updateOrderItem,
  foodSidebarScrollToButtom
} from "@redux"
import { Button } from "components"
import { productUnitLabel } from "constant"
import {
  doesItemExistInCart,
  isCustomBuilderComplete,
  isStockLimited
} from "utils"

const FoodModalDoneButton = props => {
  const {
    food,
    form,
    simpleFood,
    setOpenModal,
    initialValues
  } = props

  const [t] = useTranslation()

  const dispatch = useDispatch()

  const foodTaxesMap =
    useSelector(state => state.foodTaxesMap)

  const isSoldout = () => {
    const targetOption =
      food.options.find(option =>
        option._id === form.optionId
      )

    if (!targetOption) return true

    const result =
      targetOption.outOfStock ||
      (
        targetOption.stockManagement &&
        targetOption.availableQuantity <= 0
      )

    return result
  }

  const validate = () => {
    if (isNaN(Number(form.quantity))) {
      toast.error(
        t("unit_الزامی_است", { unit: t(productUnitLabel[food.unit]) })
      )

      return false
    }

    if (Number(form.quantity) === 0) {
      toast.error(
        t("unit_صحیح_نیست", { unit: t(productUnitLabel[food.unit]) })
      )

      return false
    }

    return true
  }

  const hasIncompleteCustomBuilder = () => (
    !!food.customBuilder?.enabled &&
    !isCustomBuilderComplete(
      food.customBuilder,
      form.specificationItems
    )
  )

  const createOrderItemData = (food, orderItemId) => {
    const option =
      food.options.find(o =>
        o._id === form.optionId
      )

    const foodTaxItems = []

    food.taxItemIds.forEach(foodTaxItemId => {
      const taxItem =
        foodTaxesMap[foodTaxItemId]

      if (!taxItem) return

      foodTaxItems.push(taxItem)
    })

    const newOrderItem = {
      orderItemId,
      foodId: food._id,
      optionId: option._id,
      code: food.code,
      isAvailable: true,
      isSimple: simpleFood,
      taxInclusive: food.taxInclusive,
      taxItems: foodTaxItems,
      unit: food.unit,
      categoryIds: food.categoryIds,
      foodImageCover: food.imageCover,
      quantity: Number(form.quantity),
      systemDiscount: Number(Math.round(form.reduction)),
      specificationItems: form.specificationItems,
      foodName: food.name,
      optionName: option.name,
      salePrice: option.salePrice,
      stockManagement: option.stockManagement,
      availableQuantity: option.availableQuantity,
    }

    return newOrderItem
  }

  const handleEdit = () => {
    if (!validate()) return
    if (hasIncompleteCustomBuilder()) {
      toast.error(t("ابتدا_همه_مراحل_اجباری_سفارشی_سازی_را_انتخاب_کنید"))

      return
    }

    const newOrderItem =
      createOrderItemData(
        food,
        initialValues.orderItemId
      )

    dispatch(
      updateOrderItem(
        newOrderItem,
        initialValues.orderItemId
      )
    )

    setOpenModal(false)
  }

  const handleAdd = () => {
    if (!validate()) return
    if (hasIncompleteCustomBuilder()) {
      toast.error(t("ابتدا_همه_مراحل_اجباری_سفارشی_سازی_را_انتخاب_کنید"))

      return
    }

    const newOrderItemId = uuidv4()

    const newOrderItem =
      createOrderItemData(food, newOrderItemId)

    const increasedQuantity =
      Number(form.quantity)

    const limitedStock =
      isStockLimited(newOrderItem, increasedQuantity)

    if (limitedStock) return

    const targetOrderItem =
      doesItemExistInCart(newOrderItem)

    targetOrderItem === null
      ?
      dispatch(
        addOrderItem(newOrderItem)
      )
      :
      dispatch(
        updateOrderItem(
          targetOrderItem,
          targetOrderItem.orderItemId
        )
      )

    dispatch(
      foodSidebarScrollToButtom()
    )

    setOpenModal(false)
  }

  const soldout = isSoldout()
  const customBuilderIncomplete =
    hasIncompleteCustomBuilder()

  const editMode = !!initialValues

  return (
    <Button
      color="success"
      disabled={soldout || customBuilderIncomplete}
      onClick={editMode ? handleEdit : handleAdd}
    >
      {soldout ? t("ناموجود") : t("افزودن")}
    </Button>
  )
}

export default FoodModalDoneButton
